import { Badge, Typography } from "antd";

import "./index.scss";

const statusColors = {
  processing: "#052987",
  success: "#32BF46",
  error: "#D2434D",
  warning: "#EF9351",
};

function BadgeStatusDot({ status = "processing", showAfter = true, text }) {
  const borderColor = statusColors[status] || statusColors.processing;
  const afterDisplay = showAfter ? "block" : "none";
  return (
    <Badge
      status={status}
      className="badge-status-dot-custom"
      style={{ "--border-color": borderColor, "--after-display": afterDisplay }}
      text={<Typography.Text style={{ color: statusColors[status] }}>{text}</Typography.Text>}
    />
  );
}

export default BadgeStatusDot;
